<ng-container *transloco="let t; prefix: 'checkout.confirmation'">
    @if ((order$ | async); as order) {

        <div class="page text-center pt-12 flex justify-center items-center flex-col">
            <div class="w-[90px] h-[90px] bg-success bg-no-repeat bg-center bg-contain mb-4 flex items-center justify-center">
                <i class="pi pi-check text-white" style="font-size: 2rem; font-weight: bold;"></i>
            </div>
            <h2 class="text-3xl font-bold text-[#00CA06]">{{ t('orderSuccess') }}</h2>
            <ul class="mt-4 w-[400px]">
                <li class="text-xl text-black font-semibold">{{ t('orderCode') }}{{ order.code }}</li>
                <li class="text-sm text-black font-normal mt-4">{{ t('checkEmail') }}</li>
            </ul>
        </div>

        @if (!order.customer.user) {
            @if (isInvoicePayment$ | async) {
                <div class="flex flex-col w-full max-w-md mx-auto gap-4 mt-6">
                    <p-button styleClass="button-secondary mt-6"
                        (click)="viewInvoice(order)">
                        {{ t('printInvoice') }}
                    </p-button>
                </div>
            }
            <div class="page border border-gray-200 rounded bg-white max-w-md mx-auto p-4 my-4">
                <p class="lead">{{ t('createAccountToEnjoy') }}</p>
                <p-button styleClass="button-base mt-6"
                        (click)="register()"
                        [disabled]="registrationSent">
                    {{ t('createAccount') }}
                </p-button>
                @if ((registrationSent)) {
                    <div class="mt-4 border-green-200 bg-green-50 p-4 text-sm text-green-700">
                        {{ t('checkEmailCompleteRegistrationStart') }}
                        <span class="text-blue-600 underline font-medium">
                            {{ order?.customer?.emailAddress }}
                        </span>
                        {{ t('checkEmailCompleteRegistrationEnd') }}
                    </div>
                }
            </div>
        
            <div class="page mt-12">
                <vsf-cart-contents 
                    [cart]="order"
                    [canAdjustQuantities]="false">
                </vsf-cart-contents>
                <vsf-cart-totals [cart]="order"></vsf-cart-totals>
            </div>
        } @else {
            <div class="flex flex-col w-full max-w-md mx-auto gap-4 mt-6">
                @if (isInvoicePayment$ | async) {
                    <a href="/api/shared/orders/rechnung-{{order.code}}.pdf?token={{sessionToken}}" target="_blank">
                        <p-button styleClass="button-base w-full" 
                            class="flex-1">
                            {{ t('printInvoice') }}
                        </p-button>
                    </a>
                }
                <p-button 
                    [styleClass]="(isInvoicePayment$ | async) ? 'button-secondary w-full' : 'button-base w-full'" 
                    class="flex-1"
                    [routerLink]="['/account/orders', order.code]">
                    {{ t('trackOrder') }}
                </p-button>
                <p-button styleClass="button-secondary w-full"
                    class="flex-1"
                    [routerLink]="['/search']"
                    [queryParams]="{ search: '_' }">
                    {{ t('continueShopping') }}
                </p-button>
            </div>
        }

    } @else {
        <div class="flex flex-col items-center justify-center min-h-[300px] gap-4">
                <p-progressSpinner 
                    [style]="{width: '3rem', height: '3rem'}" 
                    strokeWidth="3" 
                    fill="var(--gray)" 
                    animationDuration="3s">
                </p-progressSpinner>
                <p class="text-lg font-medium text-gray-700">{{ t('loading') }}</p>
            </div>
    }

@if ((notFound$ | async)) {
    <h2 class="display-4">{{ t('pageNotFound') }}</h2>
}
</ng-container>